/** "Claude Desktop wants to change something": confirm or decline, one at a time. */
import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { ActionPreviewView } from '../ai/ActionCards';
import { Dialog } from '../components/Dialog';
import { useMcpConfirm } from './state';

export function McpConfirmDialog() {
  const { t } = useTranslation();
  const { queue, answer } = useMcpConfirm();
  const current = queue[0];
  return (
    <Dialog
      open={!!current}
      onOpenChange={(o) => !o && current && answer(current.id, false)}
      title={t('mcp.confirmTitle')}
    >
      {current && (
        <div className="flex flex-col gap-3 text-sm" data-testid="mcp-confirm">
          <p className="text-fg-muted">{t('mcp.confirmIntro')}</p>
          <div className="rounded-lg border border-accent/50 bg-accent/5 p-2">
            <ActionPreviewView preview={current.preview} />
          </div>
          {queue.length > 1 && (
            <p className="text-xs text-fg-muted">{t('mcp.more', { count: queue.length - 1 })}</p>
          )}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={() => answer(current.id, false)}
              className="flex items-center gap-1 rounded-md px-3 py-1.5 text-fg-muted hover:bg-bg-hover"
            >
              <X className="size-3.5" />
              {t('ai.actions.decline')}
            </button>
            <button
              type="button"
              autoFocus
              onClick={() => answer(current.id, true)}
              className="flex items-center gap-1 rounded-full bg-accent px-3 py-1.5 font-medium text-accent-fg"
            >
              <Check className="size-3.5" />
              {t('ai.actions.confirm')}
            </button>
          </div>
        </div>
      )}
    </Dialog>
  );
}
